export const combineLocationDeptLabels = (departmentName: string, locationName: string) => {
  return `${departmentName} (${locationName})`
}

// const sensorIdString = `${sensorItem.sensorId.replace(/-/g, '')}`
